import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled, { css } from 'styled-components';
import { PreviewContent } from '../../../../data/steps-content';

export const PreviewContainer = styled.div<{ $previewContent: PreviewContent }>`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  justify-content: center;
  padding-inline: ${({ theme }) => theme.spacing.xl}px;
  padding-block: ${({ theme }) => theme.spacing.xl}px;
  ${({ $previewContent, theme }) => media.l`
   
            padding-inline: ${theme.appearance.spacing * 6}px;

    ${
      $previewContent === 'grants'
        ? css`
            min-height: 44px;
            padding-block: ${theme.appearance.spacing * 1.5}px;
          `
        : css`
            padding-block-start: ${theme.appearance.spacing * 3}px;
            padding-block-end: 0px;
            justify-content: flex-start;
          `
    }
    
  
  `}

  ${media.l`
    padding-inline: ${({ theme }) => theme.spacing.md}px;
    padding-block: ${({ theme }) => theme.spacing.lg}px;
`}
`;
